import React from 'react';
import { View, Modal, NativeSyntheticEvent, TextInputKeyPressEventData } from 'react-native';
import { translate } from '../services/translate';
import MyAppText from './MyAppText';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import Toast from 'react-native-toast-message';
import FormActions from './FormActions';
import { WindowInformation } from '../services/window-information';
import FormInput from './FormInput';


interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    onSubmit: (rejectionReason: string) => void;
    onCancel?: () => void;
}

export default function RejectionReasonModal({
    isModalVisible,
    setModalVisible,
    onSubmit,
    onCancel,
}: ModalProps) {
    const { styles } = useStyles(styleSheet);

    const [rejectionReason, setRejectionReason] = React.useState('');
    const windowInfo = WindowInformation();

    function handleKeyDown(e: NativeSyntheticEvent<TextInputKeyPressEventData>) {
        if (e.nativeEvent.key == 'Enter') {
            if (rejectionReason == '') {
                return;
            }
            onConfirm();
        }
    }

    async function onConfirm() {
        try {
            onSubmit(rejectionReason);
            setModalVisible(false);
            setRejectionReason('');
        } catch (err) {
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    return (
        <Modal
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => {
                onCancel && onCancel();
                setModalVisible(false);
                setRejectionReason('');
            }}
            transparent={true}
        >
            <View style={styles.container}>
                <View style={styles.body(windowInfo.isMobile)}>
                    <View style={{ gap: 16, justifyContent: 'center', alignItems: 'center' }}>
                        <MyAppText style={styles.headerText}>{translate('rejectionReason')}</MyAppText>
                        <MyAppText style={styles.contentText}>{translate('rejectionReasonText')}</MyAppText>
                    </View>

                    <FormInput
                        label={translate('reason')}
                        placeholder={translate('stateTheReason')}
                        value={rejectionReason}
                        onChangeText={setRejectionReason}
                        invalid={() => rejectionReason === ''}
                        multiline={true}
                        onKeyPress={handleKeyDown}
                    />
                    <FormActions
                        confirmText='confirm'
                        onSubmit={() => onConfirm()}
                        onClose={() => {
                            onCancel && onCancel();
                            setModalVisible(false);
                            setRejectionReason('');
                        }}
                        disabled={rejectionReason === ''}
                    />
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1
    },
    body: (isMobile: boolean) => {
        return {
            backgroundColor: theme.colors.white['500'],
            flexDirection: 'column',
            borderRadius: 8,
            padding: 32,
            rowGap: 25,
            maxWidth: isMobile ? '95%' : 400
        };
    },
    headerText: {
        fontSize: 18,
        color: theme.colors.neutral['500'],
        fontWeight: '600'
    },
    contentText: {
        fontSize: 16,
        color: theme.colors.neutral['400'],
    }
}));
